import $ from 'jquery';
// import App from './modules/app';
import Default from './modules/transition';
//import Cookies from './modules/cookies';
import Menu from './modules/menu';
import Carousel from './modules/carousel';
import SmoothScroll from './modules/smoothscroll';
import Animation from './modules/animation';
import Filters from './modules/filters';
import Modal from './modules/modal';
import Form from './modules/form';

window.addEventListener('DOMContentLoaded', function(){
    // App.run();
    //Cookies.run();
    Menu.run();
    Carousel.run();
    SmoothScroll.run();
    Animation.run();
    Filters.run();
    Modal.run();
    Form.run();
});
